import React, { useState, useEffect, useContext } from 'react';
import * as R from 'ramda';
import { CenterProgress } from '../component/CenterProgress';
import styles from './css/PDFView.scss';
import { store } from './store';
import { postFullURLPS } from '@cd/utils';
import { either } from '@cd/utils';
import { composePS } from '@cd/pipe';

const createPDFFromURL = R.compose(
	blob => window.URL.createObjectURL(blob),
	data =>
		new Blob([data], {
			type: 'application/pdf'
		})
);

const PDFView = ({ url }) => {
	const [PDFURL, updatePDFURL] = useState(null);
	const { dispatch } = useContext(store);
	useEffect(() => {
		postFullURLPS('GET', url, {}, false).then(
			either(
				e => dispatch({ type: 'post error', e }),
				composePS(updatePDFURL, createPDFFromURL)
			)
		);
	}, []);
	return !PDFURL ? (
		<CenterProgress />
	) : (
		<embed
			id="pdfEmbed"
			className={styles.embed}
			type="application/pdf"
			src={PDFURL}
			download={PDFURL}
		/>
	);
};

export default PDFView;
